import { FC } from 'react';
import { useDownloadConversationTranscript } from '@/entities/conversations';
import { DownloadByTemplateButton, type DownloadTemplateSelection } from '@/entities/download-template';

type Props = {
  dialogId: number;
};

export const DownloadTranscriptButton: FC<Props> = ({ dialogId }) => {
  const { mutate: download, isPending } = useDownloadConversationTranscript();

  const handleDownload = (selection: DownloadTemplateSelection) => {
    download({ id: dialogId, ...selection });
  };

  return <DownloadByTemplateButton entityType="TRANSCRIPT" onDownload={handleDownload} isPending={isPending} />;
};
